
import { defineComponent, PropType } from '@vue/runtime-core'
import ModalBase from '../genenral/ModalBase.vue'
import Button from '@/components/elements/Button.vue'
import dayjs from 'dayjs'
import { useStore } from 'vuex'
dayjs.locale('ja')
export default defineComponent({
  name: 'ModalOnlineEventConfirm',

  components: {
    ModalBase,
    Button
  },

  props: {
    closeEventConfirmModal: {
      type: Function as PropType<() => void>,
      required: true
    },
    openEventModal: {
      type: Function as PropType<() => void>,
      required: true
    },
    hospitals: {
      type: Array as PropType<string[]>
    }
  },

  setup(props) {
    const store = useStore()

    const closeModal = () => {
      store.commit('unFixBody')
      props.closeEventConfirmModal()
    }

    return {
      closeModal
    }
  }
})
